import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputPhone } from 'common/components';
import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import ButtonSection from 'features/feature-admin-profile/components/ButtonSection';
import { DividerStyled, Wrapper } from './styles';
import ChangePhoneModal from '../ChangePhoneModal';
import { professionalVerifyPhone } from 'applicaiton/store/reducers/Professionals/ActionCreators';
import { usePhoneForm } from 'features/feature-professional-edit/hooks/usePhoneForm';
import { UserType } from '@docbay/schemas/dist/user/user.types';
import PhoneChangedPopUp from '../PhoneChangedPopUp';
import { professionalProfileActions } from 'applicaiton/store/reducers/Professionals/ProfessionalProfileSlice';

const Phone: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { editedProfessional, isVerifiedOldPhone, error } = useAppSelector(
    (state) => state.professionalProfile,
  );

  const [showPhonePopUp, setShowPhonePopUp] = useState(false);
  const [isPhoneExist, setIsPhoneExist] = useState(false);
  const attemptLimitExceeded = error.endsWith('500');
  const { register, errors, handleSubmit, watch, setValue } = usePhoneForm({
    requiredError: t('errors.required'),
  });

  useEffect(() => {
    setValue('phone', editedProfessional?.phone || '');
  }, [editedProfessional]);

  const handleCloseModal = () => {
    isPhoneExist && setIsPhoneExist(false);
    setShowPhonePopUp(false);
  };

  const handleClosePhoneChangeModal = () => {
    setValue('phone', editedProfessional?.phone || '');
    dispatch(professionalProfileActions.resetPhoneData());
  };

  const handleOpenForm = async () => {
    sessionStorage.setItem('newPhone', `+${watch('phone')}`);
    sessionStorage.setItem(
      'oldPhone',
      String(editedProfessional?.phone ? editedProfessional?.phone : ''),
    );
    setShowPhonePopUp(false);

    const phone = editedProfessional?.phone
      ? String(editedProfessional?.phone)
      : `+${watch('phone')}`;

    dispatch(
      professionalVerifyPhone({
        phone,
        userType: UserType.Professional,
      }),
    );
  };

  const onSubmit = () => {
    if (editedProfessional?.phone) {
      setShowPhonePopUp(true);
    } else {
      handleOpenForm();
    }
  };

  return (
    <Wrapper onSubmit={handleSubmit(onSubmit)}>
      <div>
        <InputPhone
          id="phone"
          label={t('phone') || ''}
          register={register}
          errorMessage={
            attemptLimitExceeded
              ? t('error_attempt_limit') || ''
              : errors.phone?.message
          }
          value={watch('phone')}
          isValid={true}
        />
      </div>
      <div>
        <DividerStyled />
        <ButtonSection
          disabled={
            !!Object.keys(errors).length ||
            watch('phone') === editedProfessional?.phone
          }
        />
      </div>
      {showPhonePopUp && (
        <PhoneChangedPopUp
          onClose={handleCloseModal}
          onSubmit={handleOpenForm}
        />
      )}
      {isVerifiedOldPhone && (
        <ChangePhoneModal isOpen={true} onClose={handleClosePhoneChangeModal} />
      )}
    </Wrapper>
  );
};

export default Phone;
